import type { ReactNode } from 'react';
import { BrandMark } from '@/components/BrandMark';

export function StateCard({
  variant,
  title,
  children
}: {
  variant: 'empty' | 'forbidden';
  title: string;
  children?: ReactNode;
}): JSX.Element {
  return (
    <div className="empty-card">
      <div className="empty-icon" aria-hidden="true">
        {variant === 'empty' ? (
          <BrandMark size={28} opacity={0.45} />
        ) : (
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#0A0A0A"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity={0.6}
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M5 5 l14 14" />
          </svg>
        )}
      </div>
      <p className="empty-body" style={{ fontSize: 16, color: 'var(--text)', marginBottom: 20 }}>
        {title}
      </p>
      {children}
    </div>
  );
}
